import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Col, Row, Button } from 'reactstrap';
import Select from 'react-select';
import {
    displayErrorMessage,
} from '../../../Corporate/my-portfolio/monitoring/charts/monitoring-util'

const frequencies = [
    { value: 'DAILY', label: 'Daily' },
    { value: 'WEEKLY', label: 'Weekly' },
    { value: 'FORTNIGHTLY', label: 'Fortnightly' },
    { value: 'MONTHLY', label: 'Monthly' },
    { value: 'QUARTERLY', label: 'Quarterly' },
    { value: 'HALFYEARLY', label: 'Half Yearly' },
    { value: 'YEARLY', label: 'Yearly' },
]

const newsFrequencies = [
    { value: 'DAILY', label: 'Daily' },
    { value: 'WEEKLY', label: 'Weekly' },
    { value: 'FORTNIGHTLY', label: 'Fortnightly' },
    { value: 'MONTHLY', label: 'Monthly' },
    { value: 'QUARTERLY', label: 'Quarterly' },
]

class AddUpdatePlanForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            plan: null,
            planList: this.props.planList,
            selectedPlan: null,
            riskScoreNotif:true,
        };
    }

    handleCancel = () => {
        this.props.closeModal();
        this.resetForm();
    }

    resetForm = () => {
        this.resetWeightages();
        this.setState({
            plan: null,
            selectedPlan: null
        })
    }

    handlePlanChange = (selectedData) => {
        this.resetWeightages();
        let tempPlan = null;
        this.state.planList.forEach(item => {
            if (item.id === selectedData.value)
                tempPlan = item;
        });

        this.setWeightages(tempPlan);

        this.setState({
            selectedPlan: selectedData,
            plan: tempPlan,
            riskScoreNotif: tempPlan.riskScoreNotif,
        });
    }

    setWeightages = (plan) => {
        if (plan.gst) {
            this.props.change('gst-weight', plan.gst.weightage);
        }
        if (plan.epf) {
            this.props.change('epf-weight', plan.epf.weightage);
        }
        if (plan.mca) {
            this.props.change('mca-weight', plan.mca.weightage);
        }
        if (plan.legal) {
            this.props.change('legal-weight', plan.legal.weightage);
        }
        if (plan.ratings) {
            this.props.change('ratings-weight', plan.ratings.weightage);
        }
    }

    resetWeightages = () => {
        this.props.change('gst-weight', null);
        this.props.change('epf-weight', null);
        this.props.change('mca-weight', null);
        this.props.change('legal-weight', null);
        this.props.change('ratings-weight', null);
    }

    getFormattedFrequency = (freq) => {
        if (freq === 'DAILY') {
            return { value: 'DAILY', label: 'Daily' }
        } else if (freq === 'WEEKLY') {
            return { value: 'WEEKLY', label: 'Weekly' }
        } else if (freq === 'FORTNIGHTLY') {
            return { value: 'FORTNIGHTLY', label: 'Fortnightly' }
        } else if (freq === 'MONTHLY') {
            return { value: 'MONTHLY', label: 'Monthly' }
        } else if (freq === 'QUARTERLY') {
            return { value: 'QUARTERLY', label: 'Quarterly' }
        } else if (freq === 'HALFYEARLY') {
            return { value: 'HALFYEARLY', label: 'Half Yearly' }
        } else if (freq === 'YEARLY') {
            return { value: 'YEARLY', label: 'Yearly' }
        }
    }

    onCrawlerChecked = (e, crawler) => {
        let tempPlan = this.state.plan;

        if (!tempPlan)
            tempPlan = {}

        if (e.target.checked) {
            if (crawler === 'gst') {
                tempPlan.gst = {
                    frequency: 'DAILY',
                    weightage: null
                }
            } else if (crawler === 'epf') {
                tempPlan.epf = {
                    frequency: 'DAILY',
                    weightage: null
                }
            } else if (crawler === 'mca') {
                tempPlan.mca = {
                    frequency: 'DAILY',
                    weightage: null
                }
            } else if (crawler === 'legal') {
                tempPlan.legal = {
                    frequency: 'DAILY',
                    weightage: null
                }
            } else if (crawler === 'ratings') {
                tempPlan.ratings = {
                    frequency: 'DAILY',
                    weightage: null
                }
            } else if (crawler === 'news') {
                tempPlan.news = {
                    frequency: 'DAILY',
                    weightage: null
                }
            }
        } else { 
            
            if (crawler === 'gst') {
                this.props.change('gst-weight', null);
                delete tempPlan.gst;
            } else if (crawler === 'epf') {
                this.props.change('epf-weight', null);
                delete tempPlan.epf;
            } else if (crawler === 'mca') {
                this.props.change('mca-weight', null);
                delete tempPlan.mca;
            } else if (crawler === 'legal') {
                this.props.change('legal-weight', null);
                delete tempPlan.legal;
            } else if (crawler === 'ratings') {
                this.props.change('ratings-weight', null);
                delete tempPlan.ratings;
            } else if (crawler === 'news') {
                delete tempPlan.news;
            }
        }

        this.setState({
            plan: tempPlan
        })
    }

    onFrequencyChange = (e, crawler) => {
        let tempPlan = this.state.plan;
        if (crawler === 'gst') {
            tempPlan.gst.frequency = e.value;
        } else if (crawler === 'epf') {
            tempPlan.epf.frequency = e.value;
        } else if (crawler === 'mca') {
            tempPlan.mca.frequency = e.value;
        } else if (crawler === 'legal') {
            tempPlan.legal.frequency = e.value;
        } else if (crawler === 'ratings') {
            tempPlan.ratings.frequency = e.value;
        } else if (crawler === 'news') {
            tempPlan.news.frequency = e.value;
        }
        this.setState({
            plan: tempPlan
        })
    }

    handlePlanNameChange = (e) => {
        let tempPlan = this.state.plan;

        if (tempPlan) {
            tempPlan.planName = e.target.value;
        } else {
            tempPlan = {
                planName: e.target.value
            }
        }

        this.setState({
            plan: tempPlan
        })
    }

    mySubmittedPlan = () => {
        if (this.validatePlan() && this.validateWeightages()) {
            let plan = this.state.plan;
            plan.riskScoreNotif= this.state.riskScoreNotif;
            this.props.addEwsPlan(plan);
            this.handleCancel();
        }
    }

    validatePlan = () => {
        let isValid = true;
        this.state.planList.forEach(item => {
            if (!this.state.plan.id && item.planName.trim().toUpperCase() === this.state.plan.planName.trim().toUpperCase())
                isValid = false;
        });
        if (!isValid)
            displayErrorMessage('Plan already exists with this name.');

        if (!(this.state.plan.gst || this.state.plan.epf || this.state.plan.mca || this.state.plan.news|| this.state.plan.legal|| this.state.plan.ratings)) {
            displayErrorMessage('Choose at least one crawler.');
            isValid = false;
        }
        return isValid;
    }

    validateWeightages = () => {
        let weightage = 0;
        let emptyWeightage = false;
        if (this.state.plan.gst) {
            if (this.state.plan.gst.weightage) {
                weightage = weightage + this.state.plan.gst.weightage;
            } else {
                emptyWeightage = true;
            }
        }
        if (this.state.plan.epf) {
            if (this.state.plan.epf.weightage) {
                weightage = weightage + this.state.plan.epf.weightage;
            } else {
                emptyWeightage = true;
            }
        }
        if (this.state.plan.mca) {
            if (this.state.plan.mca.weightage) {
                weightage = weightage + this.state.plan.mca.weightage;
            } else {
                emptyWeightage = true;
            }
        }
        if (this.state.plan.legal) {
            if (this.state.plan.legal.weightage) {
                weightage = weightage + this.state.plan.legal.weightage;
            } else {
                emptyWeightage = true;
            }
        }
        if (this.state.plan.ratings) {
            if (this.state.plan.ratings.weightage) {
                weightage = weightage + this.state.plan.ratings.weightage;
            } else {
                emptyWeightage = true;
            }
        }

        if (weightage === 100) {
            if (emptyWeightage) {
                displayErrorMessage('Please add weightages for all selected crawlers.');
                return false;
            } else {
                return true;
            }
        } else if (weightage === 0) {
            return true;
        } else {
            displayErrorMessage('Weightages sum should be equal to 100.');
            return false;
        }
    }

    onWeightageChange = (e, crawler) => {
        let tempPlan = this.state.plan;
        if (crawler === 'gst') {
            tempPlan.gst.weightage = Number(e.target.value);
        } else if (crawler === 'epf') {
            tempPlan.epf.weightage = Number(e.target.value);
        } else if (crawler === 'mca') {
            tempPlan.mca.weightage = Number(e.target.value);
        } else if (crawler === 'legal') {
            tempPlan.legal.weightage = Number(e.target.value);
        } else if (crawler === 'ratings') {
            tempPlan.ratings.weightage = Number(e.target.value);
        }
        this.setState({
            plan: tempPlan
        })
    }
    

    onNotificationChoiceChange= (e) => {
        
        if (e.target.value === "risk-band"){

            this.setState({
                riskScoreNotif : false
            })
        }
        else if (e.target.value === "risk-score"){
            this.setState({
                riskScoreNotif : true
            })
        }
       
       
      }

    render() {
        const { handleSubmit } = this.props
        return (
            <form className="modal-content shadow-none border-0" onSubmit={handleSubmit(() => {
                this.mySubmittedPlan()
            })}>
                <div className="modal-header row pt-0">
                    <h5 className="mb-0">Manage Plans</h5>
                    <button type="button" onClick={this.handleCancel} className="close outline-none" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row className="mb-3 align-items-center">
                        <Col xs="4" className="filter-category py-0 py-sm-20">
                            <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Select Plan</span>
                        </Col>
                        <Col sm="11" className="filter-category py-sm-20">
                            <Select
                                value={this.state.selectedPlan}
                                onChange={this.handlePlanChange}
                                options={this.props.selectPlanList}
                                isClearable={false} />
                        </Col>
                    </Row>
                </div>

                <div className="modal-body">
                    <Row className="mb-4">
                        <div className="col-7">
                            <label>Plan Name</label>
                            <span className="text-danger">*</span>
                        </div>
                        <div className="col-17 pl-4">
                            <input
                                placeholder={'Plan Name'}
                                type={'text'}
                                value={this.state.plan ? this.state.plan.planName : ''}
                                className="form-control"
                                onChange={(e) => this.handlePlanNameChange(e)}
                                disabled={this.state.selectedPlan ? true : false}
                                required />
                        </div>
                    </Row>

                    {/* GST */}
                    <Row className="mb-4">
                        <div className="col-7">
                            <input
                                type="checkbox"
                                checked={this.state.plan && this.state.plan.gst ? true : false}
                                value={"gst"}
                                onChange={(e) => this.onCrawlerChecked(e, 'gst')} />
                            <label className='crawler-label'>GST</label>
                        </div>
                        <div className="col-12">
                            <Select
                                value={this.state.plan && this.state.plan.gst ? this.getFormattedFrequency(this.state.plan.gst.frequency) : ''}
                                onChange={(e) => this.onFrequencyChange(e, 'gst')}
                                options={frequencies}
                                isClearable={false}
                                isDisabled={!this.state.plan || !this.state.plan.gst} />
                        </div>
                        <div className="col-5">
                            <Field type="number"
                                name={`gst-weight`}
                                component="input"
                                onChange={(e) => this.onWeightageChange(e, 'gst')}
                                placeholder="Weightage"
                                className="p-2 w-100 radius-5 border risk-grade-input"
                                disabled={!this.state.plan || !this.state.plan.gst}
                                min="1"
                                max="100" />
                        </div>
                    </Row>

                    {/* EPF */}
                    <Row className="mb-4">
                        <div className="col-7">
                            <input type="checkbox"
                                checked={this.state.plan && this.state.plan.epf ? true : false}
                                value={"epf"}
                                onChange={(e) => this.onCrawlerChecked(e, 'epf')} />
                            <label className='crawler-label'>EPF</label>
                        </div>
                        <div className="col-12">
                            <Select
                                value={this.state.plan && this.state.plan.epf ? this.getFormattedFrequency(this.state.plan.epf.frequency) : ''}
                                onChange={(e) => this.onFrequencyChange(e, 'epf')}
                                options={frequencies}
                                isClearable={false}
                                isDisabled={!this.state.plan || !this.state.plan.epf} />
                        </div>
                        <div className="col-5">
                            <Field type="number"
                                name={`epf-weight`}
                                component="input"
                                onChange={(e) => this.onWeightageChange(e, 'epf')}
                                placeholder="Weightage"
                                className="p-2 w-100 radius-5 border risk-grade-input"
                                disabled={!this.state.plan || !this.state.plan.epf}
                                min="1"
                                max="100" />
                        </div>
                    </Row>

                    {/* MCA */}
                    <Row className="mb-4">
                        <div className="col-7">
                            <input type="checkbox"
                                checked={this.state.plan && this.state.plan.mca ? true : false}
                                value={"mca"}
                                onChange={(e) => this.onCrawlerChecked(e, 'mca')} />
                            <label className='crawler-label'>MCA</label>
                        </div>
                        <div className="col-12">
                            <Select
                                value={this.state.plan && this.state.plan.mca ? this.getFormattedFrequency(this.state.plan.mca.frequency) : ''}
                                onChange={(e) => this.onFrequencyChange(e, 'mca')}
                                options={frequencies}
                                isClearable={false}
                                isDisabled={!this.state.plan || !this.state.plan.mca} />
                        </div>
                        <div className="col-5">
                            <Field type="number"
                                name={`mca-weight`}
                                component="input"
                                onChange={(e) => this.onWeightageChange(e, 'mca')}
                                placeholder="Weightage"
                                className="p-2 w-100 radius-5 border risk-grade-input"
                                disabled={!this.state.plan || !this.state.plan.mca}
                                min="1"
                                max="100" />
                        </div>
                    </Row>

                    {/* LEGAL */}
                    <Row className="mb-4">
                        <div className="col-7">
                            <input type="checkbox"
                                checked={this.state.plan && this.state.plan.legal ? true : false}
                                value={"legal"}
                                onChange={(e) => this.onCrawlerChecked(e, 'legal')} />
                            <label className='crawler-label'>LEGAL</label>
                        </div>
                        <div className="col-12">
                            <Select
                                value={this.state.plan && this.state.plan.legal ? this.getFormattedFrequency(this.state.plan.legal.frequency) : ''}
                                onChange={(e) => this.onFrequencyChange(e, 'legal')}
                                options={frequencies}
                                isClearable={false} 
                                isDisabled={!this.state.plan || !this.state.plan.legal} />
                        </div>
                        <div className="col-5">
                            <Field type="number"
                                name={`legal-weight`}
                                component="input"
                                onChange={(e) => this.onWeightageChange(e, 'legal')}
                                placeholder="Weightage"
                                className="p-2 w-100 radius-5 border risk-grade-input" 
                                disabled={!this.state.plan || !this.state.plan.legal}
                                min="1"
                                max="100"/>
                        </div>
                    </Row>  

                    {/* RATINGS */}
                    <Row className="mb-4">
                        <div className="col-7">
                            <input type="checkbox"
                                checked={this.state.plan && this.state.plan.ratings ? true : false}
                                value={"ratings"}
                                onChange={(e) => this.onCrawlerChecked(e, 'ratings')} />
                            <label className='crawler-label'>RATINGS</label>
                        </div>
                        <div className="col-12">
                            <Select
                                value={this.state.plan && this.state.plan.ratings ? this.getFormattedFrequency(this.state.plan.ratings.frequency) : ''}
                                onChange={(e) => this.onFrequencyChange(e, 'ratings')}
                                options={frequencies}
                                isClearable={false}
                                isDisabled={!this.state.plan || !this.state.plan.ratings} />
                        </div>
                        <div className="col-5">
                            <Field type="number"
                                name={`ratings-weight`}
                                component="input"
                                onChange={(e) => this.onWeightageChange(e, 'ratings')}
                                placeholder="Weightage"
                                className="p-2 w-100 radius-5 border risk-grade-input"
                                disabled={!this.state.plan || !this.state.plan.ratings}
                                min="1"
                                max="100" />
                        </div>
                    </Row>

                    {/* NEWS */}
                    <Row className="mb-4">
                        <div className="col-7">
                            <input type="checkbox"
                                checked={this.state.plan && this.state.plan.news ? true : false}
                                value={"news"}
                                onChange={(e) => this.onCrawlerChecked(e, 'news')} />
                            <label className='crawler-label'>NEWS</label>
                        </div>
                        <div className="col-12">
                            <Select
                                value={this.state.plan && this.state.plan.news ? this.getFormattedFrequency(this.state.plan.news.frequency) : ''}
                                onChange={(e) => this.onFrequencyChange(e, 'news')}
                                options={newsFrequencies}
                                isClearable={false}
                                isDisabled={!this.state.plan || !this.state.plan.news} />
                        </div>
                    </Row>
                </div>
                <Row className="mb-4" onChange={this.onNotificationChoiceChange}>
                    <div className="col-7">
                        <label className='crawler-label'>Send Notification on</label>
                    </div>
                    <div className="col-7">
                        <label><Field name="notif-option" disabled={!this.state.plan} checked={this.state.riskScoreNotif} onChange={e => {}}  component="input" type="radio" value="risk-score" /> Risk Score Change</label>
                    </div>
                    <div className="col-7">
                        <label><Field name="notif-option" disabled={!this.state.plan} component="input" type="radio" value="risk-band" /> Risk Grade Change</label>
                    </div>
                </Row>

                <div className="modal-footer row pb-0">
                    <Button color="secondary" onClick={this.handleCancel}>Cancel</Button>
                    <Button color="secondary" onClick={this.resetForm}>Clear</Button>
                    <Button type="submit" color="primary">Submit</Button>
                </div>
            </form>
        )
    }
}

export default reduxForm({ form: 'AddUpdatePlanForm' })(AddUpdatePlanForm)
